import { useEffect, useState } from 'react'
import { useModal } from '../contexts/ModalContext'
import FormularioRD from '../rdstation/formularioRD'
import { cn } from '../utils/cn'
import BrandDropdown from './brandDropdown'
import Container from './container'

export default function Rodape() {
  const [activeDropdown, setActiveDropdown] = useState(null)
  const [activeSubDropdown, setActiveSubDropdown] = useState(null)
  const [isDropdownLinksOpen, setIsDropdownLinksOpen] = useState(false)
  const { openModal } = useModal()

  const socialLinks = [
    {
      name: 'Projectiva Holding',
      facebook: 'https://www.facebook.com/projectivaholding',
      instagram: 'https://www.instagram.com/projectivaholding/',
      linkedin: 'https://www.linkedin.com/company/projectivaholding',
    },
    {
      name: 'Omnicore',
      facebook: 'https://www.facebook.com/omnicoreservices/',
      instagram: 'https://www.instagram.com/omnicoreservices/',
      linkedin: 'https://www.linkedin.com/company/omnicoreservices',
    },
    {
      name: 'Be.hub',
      facebook: 'https://www.facebook.com/behubconsult/',
      instagram: 'https://www.instagram.com/behubconsult/',
      linkedin: 'https://www.linkedin.com/company/behubconsult',
    },
    {
      name: 'nex2AI',
      facebook: 'https://www.facebook.com/nex2aii/',
      instagram: 'https://www.instagram.com/nex2ai/',
      linkedin: 'https://www.linkedin.com/company/nex2ai',
    },
  ]

  const [isMobile, setIsMobile] = useState(false)

  const data = [
    {
      title: 'Solutions',
      link: '/solutions',
      items: [
        {
          title: 'ERP Excellence Center',
          link: '/erp',
          items: [
            { name: 'ERP Expertise', link: '/erp-expertise' },
            { name: 'Advisor', link: '/advisor' },
            { name: 'AMS', link: '/ams' },
            { name: 'Smartsourcing', link: '/smartsourcing' },
          ],
        },
        {
          title: 'Consulting',
          link: '/omnifactory',
          items: [{ name: 'OmniFactory', link: '/omnifactory' }],
        },
      ],
    },
    {
      title: 'Projects',
      link: '/projects',
      items: [
        {
          title: 'Development',
          link: '/development',
          items: [
            {
              name: 'Desenvolvimento de soluções',
              link: '/desenvolvimento-de-solucoes',
            },
            {
              name: 'Desenvolvimento de softwares',
              link: '/desenvolvimento-de-softwares',
            },
            {
              name: 'Recuperação de projetos',
              link: '/recuperacao-de-projetos',
            },
            { name: 'Programa New Techs', link: '/programa-new-techs' },
            { name: 'Modelos de entrega', link: '/development#modeloEntrega' },
          ],
        },
        {
          title: 'Business Agility',
          link: '/business-agility',
          items: [
            { name: 'PMO', link: '/pmo' },
            { name: 'ATO', link: '/ato' },
            { name: 'Gestão de mudança', link: '/gestao-de-mudancas' },
            { name: 'Gestão de portfolio', link: '/gestao-de-portfolio' },
          ],
        },
      ],
    },
    {
      title: 'Innovation',
      link: '/innovation',
      items: [
        {
          title: 'Intelligence',
          link: '/intelligence',
          items: [
            { name: 'IA', link: '/ia' },
            { name: 'Data', link: '/data' },
            { name: 'Finep', link: '/finep' },
          ],
        },
        {
          title: 'Cloud',
          link: '/cloud',
          items: [
            { name: 'Migração', link: '/migracao' },
            { name: 'Devops', link: '/devops' },
            { name: 'Finops', link: '/finops' },
            { name: 'Segurança', link: '/seguranca' },
            { name: 'Monitoramento', link: '/monitoramento' },
          ],
        },
      ],
    },
  ]

  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < 768)
    }

    checkIfMobile()
    window.addEventListener('resize', checkIfMobile)

    return () => {
      window.removeEventListener('resize', checkIfMobile)
    }
  }, [])

  return (
    <>
      <div className="bg-[#06060F] text-white font-roboto py-10">
        <Container className="space-y-10 lg:max-w-[1280px]">
          <div className="flex flex-col gap-10 justify-between lg:flex-row">
            <section className="flex flex-col gap-20 md:gap-8 md:flex-row md:justify-between lg:w-full">
              <div className="md:max-w-40 space-y-9">
                <div>
                  <img
                    className=""
                    src="../assets/projectiva_holding_logo.svg"
                    alt=""
                  />
                  <p className="font-inter-light">
                    Entregas <span className="font-inter-bold">efetivas</span>,{' '}
                    <span className="font-inter-bold">resultados</span> reais.
                  </p>
                </div>

                {isMobile && (
                  <button
                    onClick={() => openModal(<FormularioRD />)}
                    className="flex items-center justify-center w-44 h-14 bg-gradient-to-r from-[#4B3BDB] via-[#A002CB] to-[#FC0021] rounded-full text-sm font-medium hover:scale-105 duration-100"
                  >
                    Fale conosco
                  </button>
                )}
              </div>

              <div className="space-y-4 md:hidden">
                <BrandDropdown
                  activeDropdown={isDropdownLinksOpen}
                  setActiveDropdown={setIsDropdownLinksOpen}
                  brandName="VERTICAIS"
                  brandId="redes-sociais"
                  textSize="text-xl ps-4"
                  doesHaveUnderline={true}
                >
                  <div className="ps-4 space-y-7">
                    {data.map((item, index) => (
                      <BrandDropdown
                        key={index}
                        brandName={item.title}
                        brandId={item.link}
                        activeDropdown={activeDropdown}
                        setActiveDropdown={setActiveDropdown}
                        textSize="text-lg uppercase ps-4 font-inter-light"
                        doesHaveGradient={true}
                        doesHaveUnderline={true}
                        className="justify-baseline gap-2.5"
                      >
                        <div className="space-y-3.5 ps-4">
                          {item.items.map((subItem, subIndex) => (
                            <div key={subIndex} className="ps-4 space-y-3.5">
                              <a
                                href={subItem.link}
                                className="cursor-pointer text-white text-base block relative duration-100 group no-underline"
                              >
                                <span
                                  className={cn(
                                    'group-hover:bg-gradient-to-r group-hover:from-[#4B3BDB] group-hover:via-[#A002CB] group-hover:to-[#FC0021] group-hover:bg-clip-text group-hover:text-transparent relative font-inter-bold',
                                  )}
                                >
                                  {subItem.title}
                                  <span className="absolute left-0 bottom-[-2px] h-[1px] w-0 bg-gradient-to-r from-[#4B3BDB] via-[#A002CB] to-[#FC0021] group-hover:w-full transition-all duration-200" />
                                </span>
                              </a>

                              <div className="space-y-2 ps-4">
                                {subItem.items.map(
                                  (subSubItem, subSubIndex) => (
                                    <a
                                      key={subSubIndex}
                                      href={subSubItem.link}
                                      className="cursor-pointer text-white text-sm block relative duration-100 group no-underline"
                                    >
                                      <span
                                        className={cn(
                                          'group-hover:bg-gradient-to-r group-hover:from-[#4B3BDB] group-hover:via-[#A002CB] group-hover:to-[#FC0021] group-hover:bg-clip-text group-hover:text-transparent relative',
                                        )}
                                      >
                                        {subSubItem.name}
                                        <span className="absolute left-0 bottom-[-2px] h-[1px] w-0 bg-gradient-to-r from-[#4B3BDB] via-[#A002CB] to-[#FC0021] group-hover:w-full transition-all duration-200" />
                                      </span>
                                    </a>
                                  ),
                                )}
                              </div>
                            </div>
                          ))}
                        </div>
                      </BrandDropdown>
                    ))}
                  </div>
                </BrandDropdown>

                <hr />

                <div className="space-y-2 ps-4">
                  <a href="/blog" className="uppercase text-xl">
                    Blog
                  </a>
                </div>

                <hr />

                <BrandDropdown
                  activeDropdown={isDropdownLinksOpen}
                  setActiveDropdown={setIsDropdownLinksOpen}
                  brandName="REDES SOCIAIS"
                  brandId="redes-sociais"
                  textSize="text-xl ps-4"
                  doesHaveGradient={false}
                >
                  <div className="ps-4">
                    <section className="space-y-2.5">
                      {socialLinks.map((social, socialIndex) => (
                        <div
                          key={socialIndex}
                          className={cn(
                            'space-y-2.5',
                            socialIndex === 0 &&
                              'bg-gradient-to-r from-[rgba(75,59,219,1)] via-[rgba(160,2,203,1)] to-[rgba(252,0,33,1)] from-10% via-25% to-30% text-transparent bg-clip-text',
                            socialIndex === 1 && 'text-[rgba(75,59,219,1)]',
                            socialIndex === 2 && 'text-[rgba(160,2,203,1)]',
                            socialIndex === 3 && 'text-[rgba(252,0,33,1)]',
                          )}
                        >
                          <p>{social.name}</p>

                          <div className="flex flex-row gap-3 items-center">
                            <a
                              target="_blank"
                              href={social.facebook || '#'}
                              rel="noreferrer"
                            >
                              <div className="bg-[#fff] rounded-full p-1.5 hover:scale-110 duration-100">
                                <img
                                  src="/assets/icones/icone-facebook.svg"
                                  alt="arrow"
                                  className="w-4 h-4"
                                />
                              </div>
                            </a>
                            <a
                              target="_blank"
                              href={social.instagram || '#'}
                              rel="noreferrer"
                            >
                              <div className="bg-[#fff] rounded-full p-1.5 hover:scale-110 duration-100">
                                <img
                                  src="/assets/icones/icone-instagram.svg"
                                  alt="arrow"
                                  className="w-4 h-4"
                                />
                              </div>
                            </a>
                            <a
                              target="_blank"
                              href={social.linkedin || '#'}
                              rel="noreferrer"
                            >
                              <div className="bg-[#fff] rounded-full p-1.5 hover:scale-110 duration-100">
                                <img
                                  src="/assets/icones/icone-linkedin.svg"
                                  alt="arrow"
                                  className="w-4 h-4"
                                />
                              </div>
                            </a>
                          </div>
                        </div>
                      ))}
                    </section>
                  </div>
                </BrandDropdown>

                <hr />
              </div>

              <div className="hidden md:grid md:grid-cols-3 gap-20 md:gap-4 lg:flex lg:justify-evenly lg:w-full lg:mx-auto">
                <div className="flex flex-col gap-3 text-base">
                  <h2 className="text-white font-inter-bold text-xl">
                    VERTICAIS
                  </h2>
                  <div className="space-y-3">
                    {data.map((item, index) => (
                      <BrandDropdown
                        key={index}
                        brandName={item.title}
                        brandId={`desktop-${item.link}`}
                        activeDropdown={activeDropdown}
                        setActiveDropdown={setActiveDropdown}
                        textSize="text-base uppercase font-inter-medium"
                        doesHaveGradient={true}
                        doesHaveUnderline={true}
                        className="justify-baseline gap-2.5 pt-2"
                      >
                        <div className="space-y-2.5 pl-4">
                          {item.items.map((subItem, subIndex) => (
                            <div key={subIndex} className="space-y-2.5">
                              <a
                                href={subItem.link}
                                className="cursor-pointer text-white text-base block relative duration-100 group no-underline"
                              >
                                <span
                                  className={cn(
                                    'group-hover:bg-gradient-to-r group-hover:from-[#4B3BDB] group-hover:via-[#A002CB] group-hover:to-[#FC0021] group-hover:bg-clip-text group-hover:text-transparent relative font-inter-medium',
                                  )}
                                >
                                  {subItem.title}
                                  <span className="absolute left-0 bottom-[-2px] h-[1px] w-0 bg-gradient-to-r from-[#4B3BDB] via-[#A002CB] to-[#FC0021] group-hover:w-full transition-all duration-200" />
                                </span>
                              </a>

                              <div className="space-y-2 pl-4">
                                {subItem.items.map(
                                  (subSubItem, subSubIndex) => (
                                    <a
                                      key={subSubIndex}
                                      href={subSubItem.link}
                                      className="cursor-pointer text-white text-sm block relative duration-100 group no-underline"
                                    >
                                      <span
                                        className={cn(
                                          'font-inter-medium group-hover:bg-gradient-to-r group-hover:from-[#4B3BDB] group-hover:via-[#A002CB] group-hover:to-[#FC0021] group-hover:bg-clip-text group-hover:text-transparent relative',
                                        )}
                                      >
                                        {subSubItem.name}
                                        <span className="absolute left-0 bottom-[-2px] h-[1px] w-0 bg-gradient-to-r from-[#4B3BDB] via-[#A002CB] to-[#FC0021] group-hover:w-full transition-all duration-200" />
                                      </span>
                                    </a>
                                  ),
                                )}
                              </div>
                            </div>
                          ))}
                        </div>
                      </BrandDropdown>
                    ))}
                  </div>
                </div>
                {/* <div className="flex flex-col gap-3 text-base">
                  <h2 className="text-white font-inter-bold text-xl">
                    CASES
                  </h2>
                  {[
                    { name: 'Development', link: '/development' },
                    {
                      name: 'ERP',
                      link: '/erp',
                    },
                    { name: 'Innovation', link: '/innovation' },
                    { name: 'Cloud', link: '/cloud' },
                    { name: 'Business Agility', link: '/business-agility' },
                  ].map(service => (
                    <a
                      key={service.name}
                      href={service.link}
                      className="cursor-pointer text-white inline-block relative duration-100 group no-underline"
                    >
                      <span
                        className={cn(
                          'group-hover:bg-gradient-to-r group-hover:from-[#4B3BDB] group-hover:via-[#A002CB] group-hover:to-[#FC0021] group-hover:bg-clip-text group-hover:text-transparent relative',
                        )}
                      >
                        {service.name}
                        <span className="absolute left-0 bottom-[-2px] h-[1px] w-0 bg-gradient-to-r from-[#4B3BDB] via-[#A002CB] to-[#FC0021] group-hover:w-full transition-all duration-200" />
                      </span>
                    </a>
                  ))}
                </div> */}
                <div className="flex flex-col gap-3 text-base">
                  <a 
                    href="/blog" 
                    className="cursor-pointer text-white text-xl font-inter-bold inline-block relative duration-100 group no-underline"
                  >
                    <span className="group-hover:bg-gradient-to-r group-hover:from-[#4B3BDB] group-hover:via-[#A002CB] group-hover:to-[#FC0021] group-hover:bg-clip-text group-hover:text-transparent relative">
                      BLOG
                      <span className="absolute left-0 bottom-[-2px] h-[1px] w-0 bg-gradient-to-r from-[#4B3BDB] via-[#A002CB] to-[#FC0021] group-hover:w-full transition-all duration-200" />
                    </span>
                  </a>
                </div>
                <div className="flex flex-col gap-3 text-base">
                  <h3 className="text-white font-inter-bold text-xl">
                    REDES SOCIAIS
                  </h3>
                  <BrandDropdown
                    brandName="Projectiva Holding"
                    brandId="projectiva"
                    activeDropdown={activeDropdown}
                    setActiveDropdown={setActiveDropdown}
                    socialLinks={{
                      facebook: 'https://www.facebook.com/projectivaholding',
                      instagram:
                        'https://www.instagram.com/projectivaholding/',
                      linkedin:
                        'https://www.linkedin.com/company/projectivaholding',
                    }}
                    doesHaveUnderline
                    className="justify-baseline gap-2.5 pt-2"
                  />
                  <BrandDropdown
                    brandName="Omnicore"
                    brandId="omnicore"
                    activeDropdown={activeDropdown}
                    setActiveDropdown={setActiveDropdown}
                    socialLinks={{
                      facebook: 'https://www.facebook.com/omnicoreservices/',
                      instagram: 'https://www.instagram.com/omnicoreservices/',
                      linkedin:
                        'https://www.linkedin.com/company/omnicoreservices',
                    }}
                    doesHaveUnderline
                    className="justify-baseline gap-2.5 pt-2"
                  />
                  <BrandDropdown
                    brandName="Be.hub"
                    brandId="behub"
                    activeDropdown={activeDropdown}
                    setActiveDropdown={setActiveDropdown}
                    socialLinks={{
                      facebook: 'https://www.facebook.com/behubconsult/',
                      instagram: 'https://www.instagram.com/behubconsult/',
                      linkedin: 'https://www.linkedin.com/company/behubconsult',
                    }}
                    doesHaveUnderline
                    className="justify-baseline gap-2.5 pt-2"
                  />
                  <BrandDropdown
                    brandName="nex2AI"
                    brandId="nex2ai"
                    activeDropdown={activeDropdown}
                    setActiveDropdown={setActiveDropdown}
                    socialLinks={{
                      facebook: 'https://www.facebook.com/nex2aii/',
                      instagram: 'https://www.instagram.com/nex2ai/',
                      linkedin: 'https://www.linkedin.com/company/nex2ai',
                    }}
                    doesHaveUnderline
                    className="justify-baseline gap-2.5 pt-2"
                  />
                </div>
              </div>
            </section>

            <div className="hidden md:block md:self-end lg:self-auto">
              <button
                type="button"
                onClick={() =>
                  openModal(<FormularioRD formType="faleConosco" />)
                }
                className="flex items-center justify-center w-44 h-14 bg-gradient-to-r from-[#4B3BDB] via-[#A002CB] to-[#FC0021] rounded-full text-sm font-medium hover:scale-105 duration-100 cursor-pointer"
              >
                Fale conosco
              </button>
            </div>
          </div>

          <hr className="hidden md:block" />

          <div className="grid grid-cols-1 gap-8 md:grid-cols-2 xl:flex xl:flex-wrap xl:justify-between xl:gap-0 font-inter-light">
            <p className="text-white text-sm">Projectiva Holding</p>

            <a href="/politicadeprivacidade">
              <p className="text-white text-sm hover:bg-gradient-to-r hover:from-[#4B3BDB] hover:via-[#A002CB] hover:to-[#FC0021] hover:bg-clip-text hover:text-transparent">
                Política de Privacidade
              </p>
            </a>

            <a
              target="_blank"
              href="https://www.google.com.br/maps/place/R.+Cl%C3%A1udio+da+Silva+Pinto,+770+-+Esp%C3%ADrito+Santo,+Porto+Alegre+-+RS,+91770-545/@-30.1546669,-51.2119543,49m/data=!3m1!1e3!4m6!3m5!1s0x95198482db98031b:0x50bceff00410014f!8m2!3d-30.1545626!4d-51.2117591!16s%2Fg%2F11lmp92d3m?entry=ttu&g_ep=EgoyMDI1MDEwOC4wIKXMDSoASAFQAw%3D%3D"
              rel="noreferrer"
            >
              <div className="flex flex-row gap-2">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <title>SVG</title>
                  <path
                    d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z"
                    className="stroke-[url(#gradient)]"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M12 22C16 18 20 14.4183 20 10C20 5.58172 16.4183 2 12 2C7.58172 2 4 5.58172 4 10C4 14.4183 8 18 12 22Z"
                    className="stroke-[url(#gradient)]"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <defs>
                    <linearGradient id="gradient" x1="0" y1="0" x2="1" y2="0">
                      <stop offset="0%" stopColor="#4B3BDB" />
                      <stop offset="50%" stopColor="#A002CB" />
                      <stop offset="100%" stopColor="#FC0021" />
                    </linearGradient>
                  </defs>
                </svg>
                <p className="text-sm text-white hover:bg-gradient-to-r hover:from-[#4B3BDB] hover:via-[#A002CB] hover:to-[#FC0021] hover:bg-clip-text hover:text-transparent">
                  Porto Alegre, RS | Rua Claudio da Silva Pinto, 770 - Guarujá
                </p>
              </div>
            </a>

            <div className="flex flex-row gap-2">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <title>SVG</title>
                <path
                  d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z"
                  className="stroke-[url(#gradient)]"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M22 6L12 13L2 6"
                  className="stroke-[url(#gradient)]"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <a
                href="mailto:contato@projectivaholding.com.br"
                className="text-sm text-white align-middle object-top hover:bg-gradient-to-r hover:from-[#4B3BDB] hover:via-[#A002CB] hover:to-[#FC0021] hover:bg-clip-text hover:text-transparent"
              >
                contato@projectivaholding.com.br
              </a>
            </div>

            <a
              target="_blank"
              href="https://wa.me/5511996048800"
              rel="noreferrer"
            >
              <div className="flex flex-row gap-2">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <title>SVG</title>
                  <path
                    d="M22 16.92V19.92C22 20.4704 21.7893 20.9996 21.4142 21.3747C21.0391 21.7498 20.5099 21.9605 19.9595 21.96C16.4292 21.7383 13.0182 20.5969 10.0699 18.63C7.32663 16.8252 5.06138 14.5599 3.25652 11.8167C1.28519 8.85893 0.143768 5.43801 0.0299952 1.89767C0.0294994 1.34726 0.240161 0.818085 0.615249 0.442997C0.990337 0.067909 1.51951 -0.143164 2.06992 -0.143799H5.06992C6.0799 -0.156288 6.94705 0.5359 7.13992 1.52767C7.3609 2.7291 7.69919 3.90364 8.14992 5.03267C8.45423 5.81555 8.27462 6.7027 7.69992 7.28767L6.27992 8.70767C7.93793 11.5559 10.2439 13.8618 13.0922 15.5198L14.5122 14.0998C15.0972 13.5251 15.9843 13.3455 16.7672 13.6498C17.8963 14.1006 19.0708 14.4389 20.2722 14.6598C21.2787 14.8548 21.9812 15.7351 21.9599 16.7598L22 16.92Z"
                    className="stroke-[url(#gradient)]"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <p className="text-sm text-white items-center object-center hover:bg-gradient-to-r hover:from-[#4B3BDB] hover:via-[#A002CB] hover:to-[#FC0021] hover:bg-clip-text hover:text-transparent">
                  (11) 99604-8800
                </p>
              </div>
            </a>
          </div>
        </Container>
      </div>
    </>
  )
}
